import { useEffect, useState } from "react";

// The project's phone breakpoint (the 640px rule the stylesheets use). Lets a
// screen pick shorter copy on a handheld where every line costs a scroll.
const QUERY = "(max-width: 640px)";

export const useIsPhone = (): boolean => {
    const [isPhone, setIsPhone] = useState<boolean>(() => {
        try { return typeof window !== "undefined" && window.matchMedia(QUERY).matches; } catch { return false; }
    });
    useEffect(() => {
        let mq: MediaQueryList;
        try { mq = window.matchMedia(QUERY); } catch { return; }
        const onChange = (e: MediaQueryListEvent) => setIsPhone(e.matches);
        setIsPhone(mq.matches);
        if (typeof mq.addEventListener === "function") mq.addEventListener("change", onChange);
        else mq.addListener(onChange);
        return () => {
            if (typeof mq.removeEventListener === "function") mq.removeEventListener("change", onChange);
            else mq.removeListener(onChange);
        };
    }, []);
    return isPhone;
};
